/* eslint-disable import/prefer-default-export */
import * as load from '../../../constants/types/shared/LoadingTypes';
import { GET_SIGNUPS } from '../../../constants/types/partnership/PartnershipTypes';

export const signupHistoryReducer = (state, action) => {
  const { type , payload} = action;
  switch (type) {
    case load.LOADING_STARTS:
      return {
        ...state,
        isLoading: true,
      };

    case load.LOADING_STOPS:
      return {
        ...state,
        isLoading: false,
      };

    case GET_SIGNUPS:
      return {
        ...state,
        signups: payload,
        isLoading: false,
      };

    default:
      return state;
  }
};